module.exports = __webpack_public_path__ + "assets/img/img242.c20c31c0.png";